<script>
    import {
        goBack,
        store,
        triggerValidation,
        totalPayment,
        isDisabled,
    } from '../../Store.svelte';
    import { onDestroy, onMount } from 'svelte';
    import { navigate } from 'svelte-routing';
    import { fetchPaymentURL } from '../../clients/PaymentClient.svelte';
    import Preloader from '../../components/Preloader.svelte';
    import CartInformation from '../../components/configure/CartInformation.svelte';
    import { getStatusAdmission } from '../../clients/AdmissionClient.svelte';
    import UnauthorizedScreen from '../../components/UnauthorizedScreen.svelte';
    export let accordionClass = '';
    let interval;
    let overridePayment =
        $store.purchaseStatus.rptEliminaPagoAnticipado != null
            ? $store.purchaseStatus.rptEliminaPagoAnticipado
            : false;
    let termsAccepted = false;
    $: isNextDisabled =
        $store.requestedServices.flagAutoinstalacion && !termsAccepted;

    onMount(() => {
        window.document.dispatchEvent(
            new Event('DOMContentLoaded', {
                bubbles: true,
                cancelable: true,
            })
        );
        $store.settings.location = { progress: 75, step: 4 };
    });

    onDestroy(() => clearInterval(interval));
    // Payment stuff
    let monthlyPayment =
        $store.purchaseStatus.paymentType.indexOf('ONLINE_SAVED') >= 0 ||
        $store.requestedServices.isSpMovil;
    let monthlyPaymentAmount = 50;

    let makeMonthlyPayment = () => {
        $store.requestedServices.total = parseFloat(
            $store.requestedServices.totalOriginal
        );
        if (monthlyPayment) {
            if (overridePayment) {
                $store.requestedServices.total = parseFloat(
                    $store.purchaseStatus.installationExpress ? 100 : 1
                );
            } else {
                if (!$store.requestedServices.isSpMovil)
                    $store.requestedServices.total -= monthlyPaymentAmount;
            }
            loadPayment();
            $store.purchaseStatus.paymentType = 'ONLINE_SAVED';
        } else {
            loadPayment();
            $store.purchaseStatus.paymentType = 'ONLINE';
        }
    };

    $: paymentURL = $store.purchaseStatus.paymentURL;
    let fetchingPayment;
    let loadPayment = () => {
        paymentURL = '';
        fetchingPayment = fetchPaymentURL($store).then((response) => {
            if (response.response != null && response.response.html != null) {
                paymentURL = response.response.html;
                $store.purchaseStatus.paymentURL = response.response.html;
                $store.purchaseStatus.paymentReference =
                    response.response.reference;
            }
        });
    };
    if ($store.purchaseStatus.paymentURL == null) {
        loadPayment();
    }

    function accordionClick(event) {
        event.preventDefault();
        accordionClass == 'accordion--active'
            ? (accordionClass = '')
            : (accordionClass = 'accordion--active');
    }

    async function nextContent() {
        isLoadingAdmission = true;
        const response = await getStatusAdmission(
            $store.purchaseStatus.accountNumber
        );
        if (
            response.errorSpcCode != '200' ||
            response.situacionSpcAdmision == 'Rechazado'
        ) {
            isUnauthorized = true;
            isLoadingAdmission = false;
        } else {
            isLoadingAdmission = false;
            navigate('/compra/pago', { replace: false });
        }
    }

    function backHandler() {
        if ($store.requestedServices.flagAutoinstalacion) {
            navigate('/compra/info', { replace: false });
        } else {
            navigate('/compra/fecha', { replace: false });
        }
    }

    $: loading = false;
    $: isLoadingAdmission = false;
    $: isUnauthorized = false;
    $: {
        if ($goBack) {
            backHandler();
            goBack.set(false);
        }

        if ($triggerValidation) {
            nextContent();
            triggerValidation.set(false);
        }
    }

    if (
        !$store.purchaseStatus.paypalCompleteAgreement &&
        $store.purchaseStatus.paypalBillingAgreement == null
    ) {
        makeMonthlyPayment();
    }

    $: isDisabled.set(termsAccepted);
</script>

<div>
    <div class="pure-g justify-content-center {loading ? '' : 'hide'}">
        <div class="pure-u-1">
            <div class="text-center">
                <Preloader status={$store.purchaseStatus.status} />
            </div>
        </div>
    </div>
    <div
        class="pure-g justify-content-center {isLoadingAdmission ? '' : 'hide'}"
    >
        <div class="pure-u-1">
            <div class="text-center">
                <Preloader
                    status="Estamos procesando tu solicitud. Esto solo tomará unos momentos."
                />
            </div>
        </div>
    </div>
    {#if isUnauthorized}
        <UnauthorizedScreen />
    {/if}
    <div
        class="pure-g justify-content-center {!loading &&
        !isLoadingAdmission &&
        !isUnauthorized
            ? ''
            : 'hide'}"
    >
        <div class="pure-u-1 pure-u-md-3-4 pure-u-lg-3-5">
            <h2 class="text-fs-26 m-b-20">Verifica tu contratación</h2>
            <div class="accordion-holder">
                <div class="accordion {accordionClass}">
                    <a
                        href="#/"
                        class="accordion-title"
                        on:click={accordionClick}
                    >
                        <span>Resumen de compra</span>
                        <svg class="icon" aria-hidden="true"
                            ><use
                                xlink:href="/assets/img/icons/symbol-defs.svg#icon-angle-left"
                            /></svg
                        >
                    </a>
                    <div class="accordion-content">
                        <CartInformation />
                    </div>
                </div>
                <div class="accordion-panel m-b-15">
                    {#if !$store.requestedServices.isSpMovil}
                        <div class="panel panel--lightgray panel--slim m-b-15">
                            <div class="d-flex align-items-center">
                                <svg class="icon" aria-hidden="true"
                                    ><use
                                        xlink:href="/assets/img/icons/symbol-defs.svg#icon-calendar"
                                    /></svg
                                >
                                <div class="m-l-15">
                                    <p class="fw-semibold m-b-0">
                                        Fecha de instalación
                                    </p>
                                    <p class="m-b-0">
                                        {$store.purchaseStatus.installationDate}
                                    </p>
                                </div>
                            </div>
                        </div>
                    {/if}
                    <div>
                        <h3
                            class="h2 text-fs-20 fw-semibold primary-text"
                            class:blue-dark-text={$store.requestedServices
                                .isSky}
                        >
                            Pago para contratar
                        </h3>
                        <p class="fw-semibold">Incluye el primer mes</p>
                        <p
                            class="h2 text-fs-20 fw-semibold primary-text m-b-20"
                            class:blue-dark-text={$store.requestedServices
                                .isSky}
                        >
                            ${$totalPayment}
                        </p>
                        {#if $store.requestedServices.flagAutoinstalacion}
                            <div class="pure-g">
                                <div class="pure-u-1">
                                    <div class="d-flex align-items-center">
                                        <div class="flex-shrink-0">
                                            <label class="custom-checkbox">
                                                <input
                                                    type="checkbox"
                                                    name="terminos"
                                                    id="terminos"
                                                    bind:checked={termsAccepted}
                                                />
                                                <span class="check-icon">
                                                    <img
                                                        src="/assets/img/icons/check-icon.svg"
                                                        alt="check"
                                                    />
                                                </span>
                                            </label>
                                        </div>
                                        <label
                                            for="terminos"
                                            class="m-l-10 text-fs-13 fw-regular flex-grow-1"
                                        >
                                            acepto a pagar al proveedor
                                            $1,300.00 m.n. por cada equipo no
                                            devuelto en buen estado al término
                                            del contrato
                                        </label>
                                    </div>
                                </div>
                            </div>
                        {/if}
                    </div>
                </div>
            </div>
            <div
                class="d-flex align-items-center sidebar-top justify-content-between"
            >
                <a href="#/" class="back-button" on:click={() => backHandler()}>
                    <svg class="icon" aria-hidden="true"
                        ><use
                            xlink:href="/assets/img/icons/symbol-defs.svg#icon-arrow-left"
                        /></svg
                    >
                    <span class="fw-semibold">atrás</span>
                </a>
                <div>
                    <a
                        href="#/"
                        class={!isNextDisabled
                            ? 'pure__button continue-button'
                            : 'pure__button pure__button--disabled'}
                        on:click|preventDefault={() => nextContent()}
                    >
                        Proceder al Pago</a
                    >
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .hide {
        display: none;
    }
</style>
